export const funs = [
  {
    action: 'Play / Pause',
    shortcut: 'Space',
    alternative: 'F5 (while editing)'
  },
  {
    action: 'Rewind 5 seconds',
    shortcut: 'Ctrl ArrowLeft',
    alternative: 'F7 (while editing)'
  },
  {
    action: 'Forward 5 seconds',
    shortcut: 'Ctrl ArrowRight',
    alternative: 'F8 (while editing)'
  },
  {
    action: 'Save',
    shortcut: 'Ctrl s'
  },
  {
    action: 'Undo',
    shortcut: 'Ctrl z'
  },
  {
    action: 'Redo',
    shortcut: 'Ctrl y'
  },
  {
    action: 'Go to find / search',
    shortcut: 'Ctrl f'
  },
  {
    action: 'Go to next segment',
    shortcut: 'Ctrl ArrowDown'
  },
  {
    action: 'Go to previous segment',
    shortcut: 'Ctrl ArrowUp'
  },
  {
    action: 'Toggle linked playback',
    shortcut: 'Ctrl l'
  }
];

export const editOptions = [
  {
    action: 'Play/Pause',
    shortcut: 'Numpad5',
    alternative: 'Space'
  },
  {
    action: 'Insert segment below',
    shortcut: 'Numpad0',
    alternative: 'Ctrl Enter'
  },
  {
    action: 'Delete segment',
    shortcut: 'Option Numpad0',
    alternative: 'Ctrl Shift Backspace'
  },
  {
    action: 'Split segment',
    shortcut: 'Ctrl Numpad0',
    alternative: 'Ctrl Shift x'
  },
  {
    action: 'Segment start back',
    shortcut: 'Numpad4',
    alternative: 'Ctrl ['
  },
  {
    action: 'Segment end forward',
    shortcut: 'Numpad6',
    alternative: 'Ctrl ]'
  },
  {
    action: 'Replay segment from start',
    shortcut: 'Numpad8',
    alternative: 'Ctrl Shift p'
  },
  {
    action: 'Adjust segment start with +0.04 second',
    shortcut: 'Option Numpad4',
    alternative: 'Ctrl Shift ['
  },
  {
    action: 'Adjust segment start with -0.04 second',
    shortcut: 'Option Numpad6',
    alternative: 'Ctrl Shift ]'
  },
  {
    action: 'Adjust segment end with +0.04 second',
    shortcut: 'Ctrl Numpad4',
    alternative: 'Ctrl Option ['
  },
  {
    action: 'Adjust segment end with -0.04 second',
    shortcut: 'Ctrl Numpad6',
    alternative: 'Ctrl Option ]'
  }
];

export const funsTranscript = [
  {
    action: 'Play / Pause',
    shortcut: 'Space',
    alternative: 'F5 (while editing)'
  },
  {
    action: 'Rewind 5 seconds',
    shortcut: 'Ctrl ArrowLeft',
    alternative: 'F7 (while editing)'
  },
  {
    action: 'Forward 5 seconds',
    shortcut: 'Ctrl ArrowRight',
    alternative: 'F8 (while editing)'
  },
  {
    action: 'Undo',
    shortcut: 'Ctrl z'
  },
  {
    action: 'Redo',
    shortcut: 'Ctrl y'
  },
  {
    action: 'Go to find / search',
    shortcut: 'Ctrl f'
  },
  {
    action: 'Toggle linked playback',
    shortcut: 'Ctrl l'
  }
];

export const editOptionsTranscript = [
  {
    action: 'Bold',
    shortcut: 'Ctrl b'
  },
  {
    action: 'Italic',
    shortcut: 'Ctrl i'
  },
  {
    action: 'Underline',
    shortcut: 'Ctrl u'
  },
  {
    action: 'Strike',
    shortcut: 'Ctrl s'
  }
];
